import type { ReactNode } from 'react';
import { Icon } from './Icon';

/**
 * A care flag, as the booking modal has always drawn one.
 *
 * LIFTED OUT OF `BookingForm`, NOT COPIED (Freddi, 2026-09-16: *"lets keep the
 * same keep apart button from booking modal to household modal"*). It was a
 * local function with one call site; the household modal now needs the same
 * control for its per-dog keep-apart, and two hand-rolled checkboxes that drift
 * apart is exactly what a shared component exists to prevent. `.care-tile` and
 * its `.ct-*` children are unchanged, so the booking modal renders identically.
 *
 * `mark` is the one thing the household modal needs that a booking never does:
 * the avatar of whoever gave us this answer. It sits between the words and the
 * tick, so the tile reads icon → what it is → who said so → whether it is on.
 */
export function CareTile({
  on,
  onToggle,
  tone,
  icon,
  title,
  sub,
  mark,
}: {
  on: boolean;
  onToggle: (v: boolean) => void;
  tone?: 'meds' | 'mix';
  icon: string;
  title: string;
  sub: string;
  mark?: ReactNode;
}) {
  return (
    <button
      type="button"
      className={'care-tile' + (tone ? ` ${tone}` : '')}
      aria-pressed={on}
      onClick={() => onToggle(!on)}
    >
      <span className="ct-ic" aria-hidden="true">
        <Icon name={icon} size={16} />
      </span>
      <span className="ct-txt">
        <span className="ct-title">{title}</span>
        <span className="ct-sub">{sub}</span>
      </span>
      {mark}
      <span className="ct-tick" aria-hidden="true">
        <Icon name="check" size={11} />
      </span>
    </button>
  );
}
